import { loaderCreator } from '@/services/loaderPlugin/_base'
import { loadGtm, injectGa4Only } from '@/utils/gtm'

export const loadGa4WithoutGtm = loaderCreator(() => {
  loadGtm(injectGa4Only)
})

export default loaderCreator(() => {
  loadGtm()
})
